import { render, staticRenderFns } from "./serviceAdvantage.vue?vue&type=template&id=7051db0c&scoped=true"
import script from "./serviceAdvantage.vue?vue&type=script&lang=js"
export * from "./serviceAdvantage.vue?vue&type=script&lang=js"
import style0 from "./serviceAdvantage.vue?vue&type=style&index=0&id=7051db0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051db0c",
  null
  
)

export default component.exports